import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updateVoucherAction = createAsyncThunk(
    'update-voucher',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/store/edit-voucher/${data?.voucher_id}`,{...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateVoucherSlice = createSlice({
    name: 'update-voucher',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateVoucherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateVoucherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateVoucherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateVoucherReducer = updateVoucherSlice.reducer    